import { LitElement, html } from 'lit';

/**
 * Element to how or hide content based on a query
 *
 * @element fit-conditional-content
 */
class FitConditionalContent extends LitElement {
  render() {
    return html`<slot id="slot"></slot>`;
  }

  static get is() {
    return 'fit-conditional-content';
  }

  static get properties() {
    return {
      templates: {
        type: Array,
      },
    };
  }

  constructor() {
    super();
    this.templates = [];
    this.matchers = [];
  }

  firstUpdated() {
    this.$ = {};
    this.$.slot = this.shadowRoot.querySelector('#slot');
    this.$.slot.addEventListener('slotchange', () => { this.reloadTemplates(); });
  }

  reloadTemplates() {
    const templates = this.$.slot.assignedNodes({ flatten: true }).filter((node) => node.tagName === 'TEMPLATE');
    if (!templates.every((node) => this.templates.includes(node))
          || !this.templates.every((node) => templates.includes(node))) {
      this.templates = templates;
    }
  }

  updated(changedProperties) {
    if (changedProperties.has('templates')) {
      this.matchers.forEach(({ listener, mediaQueryList }) => mediaQueryList.removeListener(listener));
      this.matchers = this.templates.filter((template) => template.hasAttribute('query-matches')).map((template) => {
        const listener = (event) => this.renderTemplateConditionally(template, event.matches);
        const mediaQueryList = window.matchMedia(template.getAttribute('query-matches'));
        mediaQueryList.addEventListener('change', listener);
        this.renderTemplateConditionally(template, mediaQueryList.matches);
        return { listener, mediaQueryList };
      });
    }
  }

  renderTemplateConditionally(template, matches) {
    if (template._instances && !matches) {
      template._instances.forEach((child) => template.parentNode.removeChild(child));
      delete template._instances;
    } else if (!template._instances && matches) {
      const fragment = document.importNode(template.content, true);
      template._instances = Array.prototype.slice.call(fragment.children);
      template.parentNode.insertBefore(fragment, template);
    }
  }
}

customElements.define(FitConditionalContent.is, FitConditionalContent);
